import React, { Component } from 'react';
import { Nav, NavItem, Collapse } from 'reactstrap'; 
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Icon from 'react-feather';
import { css } from 'aphrodite/no-important';
import Actions from '../../../Actions';
import { sidebarStyles } from './styles';
import Permissions from '../../../Utilities/Permissions';

class SideBar extends Component {
   constructor(props){
       super(props);
       const { id = "" } = props.user;
       const permissions = new Permissions(props.permissions);
       this.sidebarData = permissions.sidebarData(id);
   }

   componentDidMount = () => {
        this.resize();
        //window.addEventListener('resize', this.resize)
   }

   resize = () => {
        const { toggleSidebar } = this.props;
        window.innerWidth < 768 ? toggleSidebar(true): null;
   }

   renderNav = (data,index) => {
       const { link, hover, icon, title } = sidebarStyles;
       let block = !data.title ? []: [(
            <h6 key={`main-${index}`} className="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
                <span className={`${css(title)}`}>{data.title}</span>
            </h6>
        )];

        data.options.map((option,sIndex) => {
            const MenuIcon = Icon[option.icon];
            block.push(
                <Nav key={`sub-${index}-${sIndex}`} vertical>
                    <NavItem>
                            <NavLink to={option.path} className={ `nav-link ${css(link, hover)}` }>
                                <MenuIcon className={ `feather ${ css(icon) }` } size={16} />
                                <span>{option.name}</span>
                            </NavLink>
                    </NavItem>
                </Nav>
            );
        });

        return block;
   }

    render() {
        const { toggle, icon, sideBar, sideBarSticky, sideBarStickyWebkit, link, hover, title } = sidebarStyles;
        const navData = this.sidebarData;
        const { sideBarState, toggleSidebar, logout, user: { email } } = this.props;
        return (            
                <Collapse isOpen={sideBarState} className={ `col-md-2 col-xs-12 bg-dark ${css(sideBar)}` }>   
                    <div className={`d-flex justify-content-end ${css(toggle)}`}>
                        <div onClick={() => toggleSidebar(sideBarState)}><Icon.X  className={css(icon)} size={16}/></div>
                    </div>
                    <div className={ `${css(sideBarSticky)} ${css(sideBarStickyWebkit)}` }>
                        {navData.map((data,index) => 
                            this.renderNav(data,index)
                        )}
                         <h6 className='px-3 mt-4 d-sm-none'>
                            <span className={`${css(title)}`}>{email}</span>
                        </h6> 
                        <Nav key={`sub-logout-1`} className="mt-2 mb-1 d-sm-none d-flex" vertical>
                            <NavItem>
                                <div className={ `nav-link ${css(link, hover)}` }>
                                    <Icon.LogOut className={ `feather ${ css(icon) }` } size={16} />
                                    <span onClick={logout}>Logout</span>
                                </div>
                            </NavItem>
                        </Nav>
                    </div>
                </Collapse>
        );
    }
  }

const mapStateToProps = (state) => ({
    user: state.auth.user,
    permissions: state.auth.permissions,
    sideBarState: state.layout.sidebar_toggle,
});
const { layout, auth } = Actions;
export default connect(mapStateToProps,{ ...auth, ...layout })(SideBar);


// WEBPACK FOOTER //
// ./src/Components/App/Layout/SideBar.js